import React from "react";
import Privacy from "../privacy";
import Provision from "../provision";

const Agreements = ({ agreements, toggleLegalInfo, setToggleLegalInfo, changeInput }) => {
  const agreementsList = [
    {
      name: "serviceTerms",
      label: "모노티 캘린더 서비스이용약관 (필수)",
      tabIndex: 10,
      button: {
        text: "약관 보기",
        onClick: () => setToggleLegalInfo("provision"),
      },
    },
    {
      name: "privacyPolicy",
      label: "모노티 캘린더 개인정보처리방침 (필수)",
      tabIndex: 11,
      button: {
        text: "약관 보기",
        onClick: () => setToggleLegalInfo("privacy"),
      },
    },
    {
      name: "marketing",
      label: "광고성정보수신 (선택)",
      tabIndex: 12,
    },
  ];

  return (
    <>
      {toggleLegalInfo === "privacy" && <Privacy setToggleLegalInfo={setToggleLegalInfo} />}
      {toggleLegalInfo === "provision" && <Provision setToggleLegalInfo={setToggleLegalInfo} />}
      <div className="all">
        <label className="check">
          <input
            type="checkbox"
            name="selectall"
            checked={agreements.selectall}
            onChange={(e) => changeInput(e)}
          />
          <strong>전체약관에 동의합니다.</strong>
        </label>
      </div>
      <ul className="agreements">
        {agreementsList.map((item) => (
          <li key={item.name}>
            <label className="check">
              <input
                type="checkbox"
                name={item.name}
                checked={agreements[item.name]}
                onChange={(e) => changeInput(e)}
                tabIndex={item.tabIndex}
              />
              <strong>{item.label}</strong>
              {item.button && (
                <button type="button" name="button" onClick={item.button.onClick}>
                  <span>{item.button.text}</span>
                </button>
              )}
            </label>
          </li>
        ))}
      </ul>
    </>
  );
};

export default Agreements;
